import { Controller } from "@hotwired/stimulus"

// Submits the form whenever a control changes (doc §15 W28): attach to the
// form and wire inputs with change->auto-submit#submit. Turbo handles the
// response (streams for the wizard's option rows).
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
